import qs from 'qs';
import LandmarksAPI from '../api/landmarksid';

import { delay } from 'redux-saga'
import {all, call, takeLatest, put, select} from 'redux-saga/effects'
import createHistory from 'history/createHashHistory'

import {getBoundsOrCenterFromGeo} from '../shared/helpers/geojson';

import {
    SAGA_LOAD_FENCES_TO_BE_VALIDATED,
    SAGA_LOAD_FENCE,
    SAGA_UPDATE_FENCE,
    SAGA_DELETE_FENCE,
    SAGA_VALIDATE_FENCE,
    SAGA_SKIP_FENCE,
    SAGA_SET_FENCE_PRIMARY_POI,
    SAGA_GET_JOBS,
    SAGA_MARK_POI_VALIDATION_STATE_COMPLETE,
    SAGA_ARCHIVE_POI,
    SAGA_MARK_POI_UNSURE,
} from './actions';

import {
    setFencesToBeValidated,
    setFence,
    serverLoadFence,
    removeFence,
    serverGetJobs,
} from './actions';

import {
    setPOI,
} from '../pois/actions';

import {
    setBounds,
    setCenter,
} from '../shared/actions';

const history = createHistory();

function getValidationPageName(task){
    if (task === 'validationPOIOrganization') return 'validOrganization';
    if (task === 'validationFixOnPremise') return 'fixOnPremise';
    if (task === 'validationFixPOICenter') return 'fixPOICenter';
    return 'poiOrganization';
}

function* getFencesToValidate(action){
  const results = yield call(LandmarksAPI.getFencesToBeValidated, 50, action.payload.searchTerm, action.payload.country);
  if (results.error === null && results.json) {
      yield put(setFencesToBeValidated(results.json.body));
  }
}

function* getFence(action) {
    yield put(removeFence(action.payload.fenceId));
    const results = yield call(LandmarksAPI.getFence, action.payload.fenceId);
    if (results.error === null && results.json) {
        yield put(setFence(results.json.body));
        yield delay(1000)

        if (results.json.body.geo.type === 'Point')
            yield put(setCenter(getBoundsOrCenterFromGeo(results.json.body.geo)));
        if (results.json.body.geo.type === 'Polygon')
            yield put(setBounds(getBoundsOrCenterFromGeo(results.json.body.geo)));
    } else {
        if (results.error === 404) {
            // If the fence is not found, redirect to the next fence to be validated
            const resultFences = yield call(LandmarksAPI.getFencesToBeValidated, 1);
            if (resultFences.error === null && resultFences.json) {
                const fences = resultFences.json.body;
                if (fences.length > 0) {
                    history.push('/loading');
                    yield delay(100)
                    history.push(`/validation/fence/${fences[0]._id}`);
                }
            }
        }
    }
}

function* updateFence(action) {
    const results = yield call(LandmarksAPI.putFence, action.payload.fenceId, action.payload.geo);
    if (results.error === null && results.json) {
        yield put(serverLoadFence(action.payload.fenceId));
    }
}

function* deleteFence(action) {
    const fenceQuery = {};

    if (action.payload.country.length > 0) fenceQuery.country = action.payload.country;
    if (action.payload.searchTerm.length > 0) fenceQuery.searchTerm = action.payload.searchTerm;

    const fenceQueryStr = qs.stringify(fenceQuery, { addQueryPrefix: true });

    const results = yield call(LandmarksAPI.removeFences, [action.payload.fenceId]);
    if (results.error === null && results.json) {
        const resultFences = yield call(LandmarksAPI.getFencesToBeValidated, 1, action.payload.searchTerm, action.payload.country);
        if (resultFences.error === null && resultFences.json) {
            const fences = resultFences.json.body;
            if (fences.length > 0) {
                history.push('/loading');
                yield delay(100)
                history.push(`/validation/fence/${fences[0]._id}${fenceQueryStr}`);
            } else {
                history.push('/validation');
            }
        }
    }
}

function* validateFence(action) {
    const fenceQuery = {};

    if (action.payload.country.length > 0) fenceQuery.country = action.payload.country;
    if (action.payload.searchTerm.length > 0) fenceQuery.searchTerm = action.payload.searchTerm;

    const fenceQueryStr = qs.stringify(fenceQuery, { addQueryPrefix: true });

    const results = yield call(LandmarksAPI.validateFence, action.payload.fenceId);
    if (results.error === null && results.json) {
        // yield put(serverLoadFence(action.payload.fenceId));
        const resultFences = yield call(LandmarksAPI.getFencesToBeValidated, 1, action.payload.searchTerm, action.payload.country);
        if (resultFences.error === null && resultFences.json) {
            const fences = resultFences.json.body;
            if (fences.length > 0) {
                history.push('/loading');
                yield delay(100);
                history.push(`/validation/fence/${fences[0]._id}${fenceQueryStr}`);
            } else {
                history.push('/validation');
            }
        }
    }
}

function* skipFence(action) {
    const fenceQuery = {};

    if (action.payload.country.length > 0) fenceQuery.country = action.payload.country;
    if (action.payload.searchTerm.length > 0) fenceQuery.searchTerm = action.payload.searchTerm;

    const fenceQueryStr = qs.stringify(fenceQuery, { addQueryPrefix: true });

    const results = yield call(LandmarksAPI.skipFence, action.payload.fenceId);
    if (results.error === null && results.json) {
        const resultFences = yield call(LandmarksAPI.getFencesToBeValidated, 1, action.payload.searchTerm, action.payload.country);
        if (resultFences.error === null && resultFences.json) {
            const fences = resultFences.json.body;
            if (fences.length > 0) {
                history.push('/loading');
                yield delay(100)
                history.push(`/validation/fence/${fences[0]._id}${fenceQueryStr}`);
            } else {
                history.push('/validation');
            }
        }
    }
}

function* setFencePrimaryPoi(action) {
    const results = yield call(LandmarksAPI.setFencePrimaryPoi, action.payload.fenceId, action.payload.poiId);
    if (results.error === null && results.json) {
        yield put(serverLoadFence(action.payload.fenceId));
    }
}

let lastOrganizationId = null;

function* getNextJob() {
    if (lastOrganizationId) {
        const poiResult = yield call(LandmarksAPI.getPOIsToBeValidated, lastOrganizationId, 'validationFixOnPremise');
        if (poiResult.error === null && poiResult.json && poiResult.statusCode !== 204) {
            const poi = poiResult.json.body;
            if (poi.validation && poi.validation.fixOnPremise && !poi.validation.fixOnPremise.completed) {
                yield put(setPOI(poi));
                history.push(`/validation/fixOnPremise/${poi._id}`);
                return;
            }
        }
        lastOrganizationId = null;
    }

    const results = yield call(LandmarksAPI.getNextJob, 1);
    if (results.error === null && results.json) {
        const job = results.json.body[0];
        const poiResult = yield call(LandmarksAPI.getPOIsToBeValidated, job.data.organizationId, job.task);

        if (poiResult.statusCode === 204) {
            yield put(serverGetJobs());
            return;
        }
        if (poiResult.error === null && poiResult.json) {
            const poi = poiResult.json.body;
            if (poi.validation[getValidationPageName(job.task)].completed) {
                yield put(serverGetJobs());
            } else {
                yield put(setPOI(poi));
                history.push(`/validation/${getValidationPageName(job.task)}/${poi._id}`);
            }
        }
    }
}

function* markPOIValidationStageComplete(action){
    const poiInfo = yield select(state => state.routes.pois.server.get('poisMap').get(action.payload.poiId));
    if (poiInfo && poiInfo.poi) {
        lastOrganizationId = poiInfo.poi.organizationId;
    }
    const results = yield call(LandmarksAPI.markValidationStageComplete, action.payload.poiId, action.payload.stage);
    if (results.error === null && results.json) {
        history.push('/loadNextJob');
    }
}

function* archivePOI(action){
    const poiInfo = yield select(state => state.routes.pois.server.get('poisMap').get(action.payload.poiId));
    if (poiInfo && poiInfo.poi) {
        lastOrganizationId = poiInfo.poi.organizationId;
    }
    const results = yield call(LandmarksAPI.removePOI, action.payload.poiId);
    if (results.error === null && results.json) {
        history.push('/loadNextJob');
    }
}

function* markUnsure(action){
    const poiInfo = yield select(state => state.routes.pois.server.get('poisMap').get(action.payload.poiId));
    if (poiInfo && poiInfo.poi) {
        lastOrganizationId = poiInfo.poi.organizationId;
    }
    const results = yield call(LandmarksAPI.markPOIUnsure, action.payload.poiId);
    if (results.error === null && results.json) {
        history.push('/loadNextJob');
    }
}

// Server functions

export default function* validationSaga(){
	yield all([
        takeLatest(SAGA_LOAD_FENCES_TO_BE_VALIDATED, getFencesToValidate),
        takeLatest(SAGA_LOAD_FENCE, getFence),
        takeLatest(SAGA_UPDATE_FENCE, updateFence),
        takeLatest(SAGA_VALIDATE_FENCE, validateFence),
        takeLatest(SAGA_SKIP_FENCE, skipFence),
        takeLatest(SAGA_SET_FENCE_PRIMARY_POI, setFencePrimaryPoi),
        takeLatest(SAGA_DELETE_FENCE, deleteFence),
        takeLatest(SAGA_GET_JOBS, getNextJob),
        takeLatest(SAGA_MARK_POI_VALIDATION_STATE_COMPLETE, markPOIValidationStageComplete),
        takeLatest(SAGA_ARCHIVE_POI, archivePOI),
        takeLatest(SAGA_MARK_POI_UNSURE, markUnsure),
	]);
}


// WEBPACK FOOTER //
// ./src/validation/sagas.js